module.exports = __webpack_public_path__ + "img/icon-financial.34e24930.svg";